import { render, staticRenderFns } from "./noticeScroll.vue?vue&type=template&id=3948ab02&scoped=true"
var script = {}
import style0 from "./noticeScroll.vue?vue&type=style&index=0&id=3948ab02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3948ab02",
  null
  
)

export default component.exports